import React, { useState } from "react";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import Modal from "../common/Modal";
import Button from "../common/Button";
import Store from "../../utils/Store";
import { get } from "lodash";
import useAddTemplate from "../ReportTemplate/services/useAddTemplate";
import Toast from "../Toast";
import { useTranslation } from "react-i18next";
import constants from "../../utils/constants";
import { useAuth } from "@qure/qure-auth";

function ReportingInfoModal({ isVisible, onClose, handleSwiftReporting }) {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const onCloseModal = () => {
    onClose(true);
  };

  const addTemplate = useAddTemplate();

  const handleCustomize = () => {
    trackEvent(MIXPANEL_EVENTS.REPORTING_INFO_CUSTOMIZE);
    onCloseModal();
    Store.update((s) => {
      s.isSettingsOpen = true;
    });
  };

  const { userInfo } = useAuth();
  const default_filter = get(userInfo, ["settings", "saved_filters"], []);
  const cxr_saved_filter_data = default_filter?.filter(
    (filter) =>
      filter.name === constants.DEFAULT_FILTER_NAME.negativeCXR && filter.is_default
  )[0];

  const handleDefaultTemplate = async () => {
    setIsLoading(true);
    try {
      let payload = {
        name: constants.DEFAULT_FILTER_NAME.negativeCXR,
        modality: "CR/DR/DX",
        template:
          '<p class="editor-paragraph" dir="ltr"><b><strong class="editor-text-bold">TECHNIQUE:</strong></b><br><span>Frontal projections of the chest were obtained</span></p><p class="editor-paragraph" dir="ltr"><br><b><strong class="editor-text-bold">FINDINGS:</strong></b><br><span>Both lung fields are clear.</span><br><span>Both costophrenic angles appear normal.</span><br><span>The tracheal lucency is centrally placed.</span><br><span>The mediastinal and diaphragmatic outlines appear normal.</span><br><span>The heart shadow is normal.</span><br><span>The bony thoracic cage and soft tissues are normal.</span></p><p class="editor-paragraph" dir="ltr"><br><b><strong class="editor-text-bold">IMPRESSION:</strong></b><br><span>1. The study is within normal limits.</span></p>',
        is_pinned: true,
        filter_data: cxr_saved_filter_data?.filter,
        filter_name: cxr_saved_filter_data?.name,
      };
      await addTemplate.mutateAsync(payload);
      trackEvent(MIXPANEL_EVENTS.REPORTING_INFO_APPLY_DEFAULT);
      Toast.success(t("default_modal_applied"));
      handleSwiftReporting();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal
        show={isVisible}
        onClose={onCloseModal}
        title={t("customize_report_template")}
        className="w-full sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-1/3"
        // closeOnClickAway
      >
        <div className="">
          <p className="text-left p-4 py-6">{t("modal.information")}</p>
          <div className="flex space-x-4 border-t border-gray-700 p-4 justify-end">
            <Button
              isSecondary
              className="grow-1 flex space-x-2 px-6 py-4 ml-4"
              onClick={handleDefaultTemplate}
              isPrimary={false}
              disabled={isLoading}
              isLoading={isLoading}
            >
              {t("button.apply_default")}
            </Button>
            <Button
              isSecondary
              className="grow-1 flex space-x-2 px-6 py-4 ml-4"
              onClick={handleCustomize}
              isPrimary={true}
              disabled={isLoading}
            >
              {t("button.customize")}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ReportingInfoModal;
